<template>
  <div class="welcome-container">
    <div class="welcome-header">
      <span class="welcome-title">欢迎来到华连生朋朋修脚ERP系统</span>
      <span class="welcome-subtitle">WELCOME TO PENGPENG FOOT CARE ERP</span>
    </div>
    <el-card class="msg-card" shadow="hover">
      <div slot="header" class="msg-card-header">
        <span class="msg-card-title">最新消息</span>
        <span class="msg-card-count" v-if="ppMsgList.length">共 {{ ppMsgList.length }} 条</span>
      </div>
      <div class="msg-list">
        <div v-for="(item, index) in ppMsgList" :key="index" class="msg-item">
          <span class="msg-index">{{ index + 1 }}</span>
          <el-tag size="mini" effect="plain" class="msg-type">{{ item.msgTypeName }}</el-tag>
          <span class="msg-content">{{ item.comment }}</span>
        </div>
        <div v-if="!ppMsgList.length" class="msg-empty">
          暂无消息通知
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orgId:'',
      ppMsgList:[]
    }
  },
  methods:{
    async loadFiveMessage(){
      const {data:res} = await this.$http.get(`/pp/msg/five/`, {params:{orgId: this.orgId}})
      this.ppMsgList = res.data;
    }
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.loadFiveMessage();
  }
}
</script>

<style scoped>
.welcome-container {
  padding: 20px;
}

.welcome-header {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 24px 28px;
  border-radius: 8px;
  background: linear-gradient(135deg, #409eff 0%, #6a5acd 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.welcome-title {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 1px;
}

.welcome-subtitle {
  margin-top: 8px;
  font-size: 12px;
  letter-spacing: 2px;
  opacity: 0.85;
}

.msg-card {
  height: 530px;
  border-radius: 8px;
}

.msg-card /deep/ .el-card__body {
  height: calc(100% - 57px);
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.msg-card /deep/ .el-card__body::-webkit-scrollbar {
  display: none;
}

.msg-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.msg-card-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.msg-card-title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 14px;
  margin-right: 8px;
  border-radius: 2px;
  background: #409eff;
  vertical-align: -1px;
}

.msg-card-count {
  font-size: 12px;
  color: #909399;
}

.msg-item {
  display: flex;
  align-items: flex-start;
  padding: 12px 10px;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.msg-item:hover {
  background-color: #f5f7fa;
}

.msg-item + .msg-item {
  border-top: 1px solid #f0f2f5;
}

.msg-index {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  line-height: 22px;
  margin-right: 12px;
  border-radius: 50%;
  background: #409eff;
  color: #fff;
  font-size: 12px;
  text-align: center;
}

.msg-type {
  flex-shrink: 0;
  margin-right: 10px;
  margin-top: 1px;
}

.msg-content {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

.msg-empty {
  padding: 60px 0;
  text-align: center;
  color: #c0c4cc;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue